"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaNetworkListResponseSubNetworkIdentifierToJSON = exports.RosettaNetworkListResponseSubNetworkIdentifierFromJSONTyped = exports.RosettaNetworkListResponseSubNetworkIdentifierFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaNetworkListResponseSubNetworkIdentifierFromJSON(json) {
    return RosettaNetworkListResponseSubNetworkIdentifierFromJSONTyped(json, false);
}
exports.RosettaNetworkListResponseSubNetworkIdentifierFromJSON = RosettaNetworkListResponseSubNetworkIdentifierFromJSON;
function RosettaNetworkListResponseSubNetworkIdentifierFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network': json['network'],
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : _1.RosettaNetworkListResponseSubNetworkIdentifierMetadataFromJSON(json['metadata']),
    };
}
exports.RosettaNetworkListResponseSubNetworkIdentifierFromJSONTyped = RosettaNetworkListResponseSubNetworkIdentifierFromJSONTyped;
function RosettaNetworkListResponseSubNetworkIdentifierToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network': value.network,
        'metadata': _1.RosettaNetworkListResponseSubNetworkIdentifierMetadataToJSON(value.metadata),
    };
}
exports.RosettaNetworkListResponseSubNetworkIdentifierToJSON = RosettaNetworkListResponseSubNetworkIdentifierToJSON;
//# sourceMappingURL=RosettaNetworkListResponseSubNetworkIdentifier.js.map